let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jO2ep")).then(() => parcelRequire('gtWWT'));